import { useAuth0 } from '@auth0/auth0-react';

/**
 * Hook to get the authenticated user's Auth0 ID (sub claim).
 * Returns the user's unique identifier from Auth0 JWT token.
 *
 * @returns {string} The user's Auth0 ID (sub claim), or empty string if not authenticated
 *
 * @example
 * ```typescript
 * const userId = useAuthUserId();
 * // Returns: "auth0|69019a2365148bd755e83a77"
 *
 * // Use in API headers
 * const headers = { 'X-Partner-Id': userId };
 * ```
 */
export const useAuthUserId = (): string => {
  const { user } = useAuth0();
  return user?.sub || '';
};
